import { render, staticRenderFns } from "./authorVideoFans.vue?vue&type=template&id=b9f94d24&scoped=true"
import script from "./authorVideoFans.vue?vue&type=script&lang=js"
export * from "./authorVideoFans.vue?vue&type=script&lang=js"
import style0 from "./authorVideoFans.vue?vue&type=style&index=0&id=b9f94d24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f94d24",
  null
  
)

export default component.exports